function TriangleExclamation() {
  return (
    <svg width='61' height='60' viewBox='0 0 61 60' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='triangle-exclamation'>
        <path
          id='triangle-exclamation_2'
          d='M54.5174 42.8805L38.0001 11.99C34.8001 6.00497 26.2026 6.00497 23.0001 11.99L6.48275 42.8805C3.54775 48.3705 7.53284 55.0002 13.7703 55.0002H47.2298C53.4648 55.0002 57.4524 48.368 54.5174 42.8805ZM28.6251 25.0002C28.6251 23.9652 29.4651 23.1252 30.5001 23.1252C31.5351 23.1252 32.3751 23.9652 32.3751 25.0002V35.0002C32.3751 36.0352 31.5351 36.8752 30.5001 36.8752C29.4651 36.8752 28.6251 36.0352 28.6251 35.0002V25.0002ZM30.5501 45.0002C29.1701 45.0002 28.0373 43.8802 28.0373 42.5002C28.0373 41.1202 29.1451 40.0002 30.5251 40.0002H30.5501C31.9326 40.0002 33.0501 41.1202 33.0501 42.5002C33.0501 43.8802 31.9301 45.0002 30.5501 45.0002Z'
          fill='#DC3545'
        />
      </g>
    </svg>
  );
}

export default TriangleExclamation;
